export const BASE_API_URL = "https://api.vlc-control.lionsarena.md";

// номер версии с датой
export const version = "3.3.0 от 03.09.2026";
